import prepareNunjucksTemplate from '@buzzfeed/buzzblocks/js/services/nunjucks-env/standalone';

/**
 * @param {Object} args
 * @param {Object} args.template - either Svelte component or compiled nunjucks template
 * @param {Object} [args.props] - component properties
 * @param {Element} args.target - element to render to (will be inserted after existing content)
 * @param {Element} [args.anchor] - child of `target` to render the component immediately before
 * @returns {Object} - Svelte component instance, or nothing in the case of nunjucks templates
 */
function renderTemplate(_ref) {
  let {
    template,
    props,
    target,
    anchor
  } = _ref;
  if (typeof template === 'function' && '$set' in template.prototype) {
    // if Svelte component
    const SvelteComponent = template;
    return new SvelteComponent({
      props,
      target,
      anchor
    });
  } else if ('env' in template) {
    // if nunjucks template
    const html = prepareNunjucksTemplate(template).render(props);
    if (!anchor) {
      target.insertAdjacentHTML('beforeend', html);
    } else {
      // Svelte uses `target.insertBefore` when an anchor is specified,
      // but since a rendered nunjucks template is a string,
      // `insertAdjacentHTML` is more suitable;
      // doing some checks to match Svelte's behavior
      if (!(anchor instanceof Node)) {
        throw new TypeError('`anchor` is not of type `Node`');
      }
      if (anchor.parentElement !== target) {
        // should be a `DOMException`, but the constructor is not supported in Edge (and IE?)
        throw new Error('`anchor` is not a child of `target`');
      }
      anchor.insertAdjacentHTML('beforebegin', html);
    }
    return null;
  }
  return null;
}

export { renderTemplate as default };
